import React from 'react'
import { BoxHeader, BoxTitle } from '../../ui/box'
import Shorten from '../../helper/shorten'
import { TraceSpanCategory } from '../../domain/Trace'

type Props = {
    category: TraceSpanCategory
    isRoot: boolean
    name: string
    namespace?: string
}

export class TraceDetailsTitle extends React.PureComponent<Props> {
    render() {
        const { category, isRoot, name, namespace } = this.props
        return (
            <BoxHeader>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'baseline' }}>
                    <div className={'category category-' + category.className}>{category.label}</div>
                    <div>
                        <BoxTitle>
                            <Shorten string={name} />
                        </BoxTitle>
                        {namespace ? <h4 className="box-title namespace">{namespace}</h4> : null}
                    </div>
                </div>
            </BoxHeader>
        )
    }
}
